module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAMAAAC7IEhfAAAARVBMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////9SnXPCAAAAFnRSTlMA13qrm7Xmimewpb6Tb1Dxgl89SRMSxePIOAAAAMtJREFUOMvtlMsOgjAQRS/SduhLEbT//6lapxHoYLowxg1ndw+XSWDSYuFKVzBrIfEpJbsW/VN4CIaUcYtwLzGUVPukUFCc3c5EhjhSiQMEOjGnHGIJGjucyRsewuONpzM+cZ+iM/Ns+jjdUDHqN9YFImWnySqi4OzyZMxfV2MAI6TCRbgO6IS88MvtovlnMUmwK+OpJm9GyIhfELotGtCVCsh4sQSxLs9no/17+qN4FL8s2nbRIqPbRc33Yvu4lntyDmrNCIwbEXLvAeiWUUHi5lH0AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/images/winner/prize.png
// module id = GghJ
// module chunks = 1